export const OrderStatus = [
  'ORDER_CREATED',
  'ORDER_ORDERABLE',
  'ORDER_ORDERED',
  'ORDER_REJECTED',
  'ORDER_EMBOSSED',
  'ORDER_FINISHED',
  'ORDER_EXPEDITED',
  'ORDER_CANCELLED'
]
